import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Renderer2,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { InViewportModule } from 'ng-in-viewport';
import { NgFor, NgStyle } from '@angular/common';

@Component({
  selector: 'popsy-skeleton',
  templateUrl: './popsy-skeleton.template.html',
  styleUrls: ['./popsy-skeleton.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, InViewportModule, NgStyle],
})
export class PopsySkeletonComponent implements OnInit, OnChanges {
  @Input() public count?: number | null = null;
  @Input() public appearance?: string | null = null;
  @Input() public theme?: { [k: string]: string } | null = {};

  public styles: { [k: string]: any };
  public items: Array<any>;

  constructor(private readonly renderer: Renderer2) {
    this.items = new Array(0);
    this.styles = {};
  }

  public ngOnInit(): void {
    this.styles = this.theme || {};
    this.items.length = this.count || 1;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.count) {
      this.items.length = this.count || 1;
    }

    if (changes.theme) {
      this.styles = this.theme || {};
    }
  }

  public onIntersection({
    target,
    visible,
  }: {
    target: Element;
    visible: boolean;
  }): void {
    this.renderer.setStyle(
      target,
      'animation',
      visible ? 'progress 2s ease-in-out infinite' : 'none'
    );
  }

  public trackByItem(index: number): string {
    return `${index}`;
  }
}
